import { getReferralLinkByTokenMutation, publicInsertReferralMutation, getReferralByIdQuery } from '~graphql/referrals.graphql'
import {
  getAllReferralLinksQuery,
  createReferralLinkMutation,
  updateReferralLinkMutation,
  deleteReferralLinkMutation
} from '~graphql/referralLinks.graphql'

export default {
  getReferralLinkByToken({ state, dispatch }, token) {
    return dispatch('getItems', {
      state,
      loader: 'getReferralLink',
      query: getReferralLinkByTokenMutation,
      resultPath: 'getReferralLink.results',
      variables: {
        token
      }
    })
  },
  getReferralById({ dispatch, state }, referralId) {
    return dispatch('getItemById', {
      id: referralId,
      state,
      loader: 'referral:get',
      query: getReferralByIdQuery,
      resultPath: 'referral'
    })
  },
  publicInsertReferral({ state, dispatch }, referral) {
    return dispatch('createItem', {
      item: { referral },
      state,
      loader: 'referral:create',
      mutation: publicInsertReferralMutation,
      resultPath: 'publicInsertReferral.uuid'
    })
  },
  getAllReferralLinks({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'referralLinks:get',
      modelName: 'referralLinks',
      query: getAllReferralLinksQuery,
      resultPath: 'referralLinks.nodes'
    })
  },
  createReferralLink({ state, dispatch }, referralLink) {
    return dispatch('createItem', {
      item: referralLink,
      state,
      loader: 'referralLink:persist',
      addTo: ['referralLinks'],
      mutation: createReferralLinkMutation,
      resultPath: 'createReferralLink.referralLink'
    })
  },
  updateReferralLink({ state, dispatch }, referralLink) {
    return dispatch('updateItem', {
      item: referralLink,
      state,
      addTo: ['referralLinks'],
      loader: 'referralLink:persist',
      mutation: updateReferralLinkMutation,
      resultPath: 'updateReferralLink.referralLink'
    })
  },
  deleteReferralLink({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['referralLinks'],
      loader: 'referralLink:delete',
      mutation: deleteReferralLinkMutation
    })
  }
}
